var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvertCurIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E4F8DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54077 7.16247C9.75156 7.37943 9.75156 7.73119 9.54077 7.94815L8.8429 8.66642H16.4602C16.7583 8.66642 17 8.91515 17 9.22198C17 9.5288 16.7583 9.77753 16.4602 9.77753H8.8429L9.54077 10.4958C9.75156 10.7128 9.75156 11.0645 9.54077 11.2815C9.32997 11.4984 8.98821 11.4984 8.77741 11.2815L7.1581 9.61482C6.9473 9.39786 6.9473 9.0461 7.1581 8.82914L8.77741 7.16247C8.98821 6.94552 9.32997 6.94552 9.54077 7.16247ZM14.4592 12.718C14.67 12.5011 15.0118 12.5011 15.2226 12.718L16.8419 14.3847C17.0527 14.6017 17.0527 14.9534 16.8419 15.1704L15.2226 16.837C15.0118 17.054 14.67 17.054 14.4592 16.837C14.2484 16.6201 14.2484 16.2683 14.4592 16.0514L15.1571 15.3331H7.53977C7.24166 15.3331 7 15.0844 7 14.7775C7 14.4707 7.24166 14.222 7.53977 14.222H15.1571L14.4592 13.5037C14.2484 13.2867 14.2484 12.935 14.4592 12.718Z",
    fill: "#92E27C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertCurIcon);
export default __webpack_public_path__ + "static/media/convert-cur-icon.62e1b0d8457fba3844c19a969b4e401a.svg";
export { ForwardRef as ReactComponent };